/* DATORACODE - Countdown Timer: counts down to an absolute Unix timestamp handed over by Liquid.
   Timezone resolution happens server-side (see snippets/countdown-date.liquid) — this component only
   diffs the target against the visitor's clock, so the markup survives Shopify's page cache. */

(function () {
  if (customElements.get('countdown-timer')) return;

  /* Separatoren gehoeren IN die Klammern: buildSegments() behaelt nur den Klammer-Inhalt,
     Text zwischen den Gruppen fiele weg. So verschwindet der Doppelpunkt ausserdem zusammen
     mit seinem Segment, wenn das eingeklappt wird. */
  const DEFAULT_FORMAT = '[%days%:][%hours%:][%minutes%:][%seconds%]';
  const SEGMENT_PATTERN = /\[([^\]]*)\]/g;
  const TOKEN_PATTERN = /(%days%|%hours%|%minutes%|%seconds%)/g;
  const UNITS = {
    '%days%': 'days',
    '%hours%': 'hours',
    '%minutes%': 'minutes',
    '%seconds%': 'seconds',
  };
  /* Largest first — a zero segment is dropped only while every larger one is zero too, so the
     display collapses as the countdown runs down instead of flickering at "3 days, 0 hours". */
  const ORDER = ['days', 'hours', 'minutes', 'seconds'];
  const ALWAYS_VISIBLE = ['hours','minutes', 'seconds'];

  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.stopTicking();

      this.endTime = this.parseTimestamp(this.dataset.end);
      this.startTime = this.parseTimestamp(this.dataset.start);
      if (this.endTime === null) return;

      this.valueElements = { days: [], hours: [], minutes: [], seconds: [] };
      this.segmentElements = { days: [], hours: [], minutes: [], seconds: [] };
      this.buildSegments(this.resolveFormat());

      this.setAttribute('role', 'timer');
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      this.stopTicking();
    }

    stopTicking() {
      if (this.interval) clearInterval(this.interval);
      this.interval = null;
    }

    /* Seconds since epoch, or null when the setting was blank or unparseable. */
    parseTimestamp(value) {
      const parsed = Number.parseInt(value, 10);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    }

    /* Falls back to the default when a per-market translation dropped the placeholders. */
    resolveFormat() {
      const format = this.dataset.format || '';
      return format.match(TOKEN_PATTERN) ? format : DEFAULT_FORMAT;
    }

    /* Each [...] group becomes its own element so segments can be laid out individually.
       Placeholders become empty spans that tick() writes into — no innerHTML churn per second. */
    buildSegments(format) {
      const fragment = document.createDocumentFragment();
      const groups = [...format.matchAll(SEGMENT_PATTERN)].map((match) => match[1]);
      const segments = groups.length ? groups : [format];

      /* Gruppen ohne Platzhalter — Separatoren wie [:] — tragen keine eigene Einheit und wuerden
         sonst nie eingeklappt: bei ausgeblendeten Tagen bliebe ein fuehrendes ":" stehen. Sie
         erben deshalb die Sichtbarkeit der Einheit DAVOR. Gruppen vor der ersten Einheit haben
         kein "davor" und bleiben dauerhaft sichtbar — das ist der Fall fuer Vortext wie
         [Endet in ], der einen eingeklappten Tages-Teil ueberleben soll. Soll er mit
         verschwinden, gehoert er ins Platzhalter-Segment: [Endet in %days% Tagen]. */
      let lastUnit = null;

      segments.forEach((segment) => {
        const parts = segment.split(TOKEN_PATTERN).filter(Boolean);

        const wrapper = document.createElement('span');
        wrapper.className = 'countdown-timer__segment';

        /* A label belongs to the nearest placeholder before it, falling back to the segment's own
           one so leading words ("noch 3 Tage") are attributed like trailing ones. */
        const segmentUnit = parts.map((part) => UNITS[part]).find(Boolean);
        let currentUnit = segmentUnit;
        if (segmentUnit) {
          this.bindSegment(wrapper, segmentUnit);
          lastUnit = segmentUnit;
        } else if (lastUnit) {
          this.bindSegment(wrapper, lastUnit);
        }

        parts.forEach((part) => {
          const unit = UNITS[part];

          if (unit) {
            currentUnit = unit;
            const value = document.createElement('span');
            value.className = 'countdown-timer__value';
            value.dataset.unit = unit;
            this.valueElements[unit].push(value);
            wrapper.appendChild(value);
            return;
          }

          const label = document.createElement('span');
          label.className = 'countdown-timer__label';
          if (currentUnit) label.dataset.label = currentUnit;
          label.textContent = part;
          wrapper.appendChild(label);
        });

        fragment.appendChild(wrapper);
      });

      this.replaceChildren(fragment);
    }

    /* Haengt ein Segment an eine Einheit, damit collapseLeadingZeros() es mitschaltet. */
    bindSegment(element, unit) {
      element.dataset.unit = unit;
      this.segmentElements[unit].push(element);
    }

    /* Recomputed from Date.now() every tick, so throttled background tabs self-correct. */
    tick() {
      const now = Math.floor(Date.now() / 1000);

      if (this.startTime !== null && now < this.startTime) {
        this.setVisible(false);
        return;
      }

      const remaining = this.endTime - now;
      if (remaining <= 0) {
        this.setVisible(false);
        this.stopTicking();
        return;
      }

      const values = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor((remaining % 86400) / 3600),
        minutes: Math.floor((remaining % 3600) / 60),
        seconds: remaining % 60,
      };

      this.write('days', values.days);
      this.write('hours', values.hours, 2);
      this.write('minutes', values.minutes, 2);
      this.write('seconds', values.seconds, 2);
      this.collapseLeadingZeros(values);
      this.setVisible(true);
    }

    write(unit, value, padTo) {
      const text = padTo ? String(value).padStart(padTo, '0') : String(value);
      this.valueElements[unit].forEach((element) => {
        if (element.textContent !== text) element.textContent = text;
      });
    }

    /* Segments without a placeholder carry no unit and are never touched here. */
    collapseLeadingZeros(values) {
      let reached = false;

      ORDER.forEach((unit) => {
        if (values[unit] > 0) reached = true;
        const visible = reached || ALWAYS_VISIBLE.includes(unit);
        this.segmentElements[unit].forEach((element) => this.display(element, visible));
      });
    }

    setVisible(visible) {
      this.display(this, visible);
    }

    /* `hidden` loses to any display rule in component-countdown-timer.css, so the inline style
       stays authoritative; the attribute is kept for semantics and pre-JS state. */
    display(element, visible) {
      if (visible) {
        element.removeAttribute('hidden');
        element.style.removeProperty('display');
      } else {
        element.setAttribute('hidden', '');
        element.style.display = 'none';
      }
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
})();
